import { motion } from "framer-motion";

const SectionDivider = () => (
  <div className="relative h-14 overflow-hidden md:h-20">
    <motion.div
      className="absolute left-1/2 top-1/2 h-px -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-transparent via-primary/60 to-transparent"
      initial={{ width: 0 }}
      whileInView={{ width: "10rem" }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    />
    <motion.div
      className="absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border border-primary/40 bg-background"
      initial={{ opacity: 0, scale: 0 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ delay: 0.4 }}
    />
  </div>
);

export default SectionDivider;
